export const calculate_percentage = (part: number, whole: number) => {
  return (100 - (part / whole) * 100).toFixed(1);
};
